import { ProgramItem } from '@/widgets/ProgramItem';
import { EnrollmentListItem, isAwaitingEnrollmentItem } from '@/entities/Enrollment';
import { enrollmentDto } from '../../config/enrollmentDto';
import { AwaitingEnrollmentCard } from '../AwaitingEnrollmentCard';
interface EnrollmentsListProps {
  list: EnrollmentListItem[];
  /** Своё сообщение на каждую вкладку: одно на обе врало на «Active». */
  emptyMessage?: string;
}

export const EnrollmentsList = ({ list, emptyMessage }: EnrollmentsListProps) => {
  if (list.length === 0) {
    return (
      <div className="min-h-[300px] flex items-center justify-center">
        <h2 className="text-lg text-grey-secondary">
          {emptyMessage || 'There are no courses here.'}
        </h2>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-y-6">
      {list.map((item) =>
        // Курс без группы или расписания: программа без входа в уроки
        isAwaitingEnrollmentItem(item) ? (
          <AwaitingEnrollmentCard key={`awaiting-${item.enrollmentId}`} item={item} />
        ) : (
          <ProgramItem key={item.id} courseItem={enrollmentDto(item)} isDetailProgress />
        ),
      )}
    </div>
  );
};
